module.exports = __webpack_public_path__ + "img/mail-icon.2674eef4.svg";